import React, { useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import LoadingIndicator from "../../components/LoadingIndicator";
import webService from "../../services/web.service";
import { toast } from "react-hot-toast";

function StructurePreviewEdit({ language }) {
  const { token, id_config } = useParams();
  const [loading, setLoading] = React.useState(true);
  const [isDisabled, setIsDisabled] = React.useState(false);
  const [structurePreview, setStructurePreview] = React.useState({});

  const inputFileRef1 = useRef();
  const inputFileRef2 = useRef();
  function handleImageChange1(e) {
    setStructurePreview({
      ...structurePreview,
      image1: URL.createObjectURL(e.target.files[0]),
      image1_obj: e.target.files[0],
    });
  }
  function handleImageChange2(e) {
    setStructurePreview({
      ...structurePreview,
      image2: URL.createObjectURL(e.target.files[0]),
      image2_obj: e.target.files[0],
    });
  }

  React.useEffect(() => {
    if (id_config) fetchStructurePreview();
  }, [language]);

  const fetchStructurePreview = async () => {
    webService.getStructurePreview(token, id_config, language.value).then(
      (result) => {
        setStructurePreview(result.data);
        setLoading(false);
      },
      (error) => {
        toast.error("Si è verificato un errore");
        setIsDisabled(false);
      }
    );
  };

  const saveStructurePreview = async () => {
    setIsDisabled(true);

    const formData = new FormData();
    formData.append("image1", structurePreview.image1_obj);
    formData.append("image2", structurePreview.image2_obj);
    formData.append(
      "structurePreview",
      JSON.stringify({
        ...structurePreview,
        image1_obj: null,
        image2_obj: null,
      })
    );

    webService
      .saveStructurePreview(token, id_config, language.value, formData)
      .then(
        (result) => {
          if (result.status === 200) {
            setStructurePreview(result.data);
            toast.success("L'anteprima della struttura è stata salvata");
          } else toast.error("Si è verificato un errore");
          setIsDisabled(false);
        },
        (error) => {
          toast.error("Si è verificato un errore");
          setIsDisabled(false);
        }
      );
  };

  const onBtnClick1 = () => {
    inputFileRef1.current.click();
  };
  const onBtnClick2 = () => {
    inputFileRef2.current.click();
  };

  const StructurImage1 = ({ url }) => (
    <div className="rounded-lg bg-white shadow p-5">
      <div className="flex flex-row items-center">
        <h2 className="font-semibold text-lg">Foto #1</h2>

        <input
          type="file"
          onChange={handleImageChange1}
          ref={inputFileRef1}
          className="hidden"
        />
        <span
          className="ml-auto cursor-pointer text-indigo-600 
                py-2 text-base font-medium 
                 hover:text-indigo-700"
          onClick={onBtnClick1}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-6 h-6"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 16.5V9.75m0 0l3 3m-3-3l-3 3M6.75 19.5a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z"
            />
          </svg>
        </span>
        {url && (
          <span
            className="cursor-pointer text-indigo-600 
                px-5 py-2 text-base font-medium 
                 hover:text-indigo-700"
            onClick={() => {
              if (window.confirm("Eliminare la foto selezionata?")) {
                setStructurePreview({ ...structurePreview, image1: null });
              }
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-6 h-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </span>
        )}
      </div>
      <div className="mt-5 h-full">
        {url ? (
          <img
            src={url}
            alt={"structure-preview-1"}
            className="object-cover w-92 h-72 rounded-lg mt-5"
            loading="lazy"
          />
        ) : (
          <div className="flex flex-col items-center h-full w-full">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-12 h-12 text-gray-300"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M2.25 13.5h3.86a2.25 2.25 0 012.012 1.244l.256.512a2.25 2.25 0 002.013 1.244h3.218a2.25 2.25 0 002.013-1.244l.256-.512a2.25 2.25 0 012.013-1.244h3.859m-19.5.338V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 00-2.15-1.588H6.911a2.25 2.25 0 00-2.15 1.588L2.35 13.177a2.25 2.25 0 00-.1.661z"
              />
            </svg>
            <p className="text-gray-300">Nessuna foto.</p>
          </div>
        )}
      </div>
    </div>
  );
  const StructurImage2 = ({ url }) => (
    <div className="rounded-lg bg-white shadow p-5">
      <div className="flex flex-row items-center">
        <h2 className="font-semibold text-lg">Foto #2</h2>
        <input
          type="file"
          onChange={handleImageChange2}
          ref={inputFileRef2}
          className="hidden"
        />
        <span
          className="ml-auto cursor-pointer text-indigo-600 
                py-2 text-base font-medium 
                 hover:text-indigo-700"
          onClick={onBtnClick2}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-6 h-6"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 16.5V9.75m0 0l3 3m-3-3l-3 3M6.75 19.5a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z"
            />
          </svg>
        </span>
        {url && (
          <span
            className="cursor-pointer text-indigo-600 
                px-5 py-2 text-base font-medium 
                 hover:text-indigo-700"
            onClick={() => {
              if (window.confirm("Eliminare la foto selezionata?")) {
                setStructurePreview({ ...structurePreview, image2: null });
              }
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-6 h-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </span>
        )}
      </div>
      <div className="mt-5 h-full">
        {url ? (
          <img
            src={url}
            alt={"structure-preview-2"}
            className="object-cover w-92 h-72 rounded-lg mt-5"
            loading="lazy"
          />
        ) : (
          <div className="flex flex-col items-center h-full w-full">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-12 h-12 text-gray-300"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M2.25 13.5h3.86a2.25 2.25 0 012.012 1.244l.256.512a2.25 2.25 0 002.013 1.244h3.218a2.25 2.25 0 002.013-1.244l.256-.512a2.25 2.25 0 012.013-1.244h3.859m-19.5.338V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 00-2.15-1.588H6.911a2.25 2.25 0 00-2.15 1.588L2.35 13.177a2.25 2.25 0 00-.1.661z"
              />
            </svg>
            <p className="text-gray-300">Nessuna foto.</p>
          </div>
        )}
      </div>
    </div>
  );

  return (
    <>
      {loading ? (
        <div className="w-full h-full flex items-center justify-center">
          <LoadingIndicator />
        </div>
      ) : (
        <>
          <div className="bg-gray-100">
            <div className="pt-5 pr-5 w-full flex justify-end">
              <button
                className={`rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600`}
                onClick={saveStructurePreview}
                type="button"
              >
                Salva l'anteprima della struttura
              </button>
            </div>
            <div className="flex flex-col p-5">
              <div className="w-full">
                <label
                  htmlFor="body-advisor"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  Testo Anteprima
                </label>
                <div className="mt-2">
                  <textarea
                    id="body-structure-preview"
                    rows={3}
                    className="block w-full rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:py-1.5 sm:text-sm sm:leading-6"
                    defaultValue={""}
                    placeholder="Es. Prenota oggi la nostra struttura e avrai inclusi..."
                    value={structurePreview.description_obj.text}
                    onChange={(e) =>
                      setStructurePreview({
                        ...structurePreview,
                        description_obj: {
                          ...structurePreview.description_obj,
                          text: e.target.value,
                        },
                      })
                    }
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-5 p-5 pl-0">
                <StructurImage1 url={structurePreview.image1} />
                <StructurImage2 url={structurePreview.image2} />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default StructurePreviewEdit;
